import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type DeleteGoalInput = {
  id: string;
  /** Partner the goal was bound to (null for org-wide). Used for cascade. */
  partnerId: string | null;
};

// DELETE /api/admin/goals/:id
//
// Hard delete — cascades through partner_goal_targets. Pessimistic.
export function useDeleteGoal() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, DeleteGoalInput>({
    mutationFn: ({ id }) =>
      apiFetch<{ ok: true }>(`/admin/goals/${id}`, { method: "DELETE" }),
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.goals.list() });
      if (partnerId) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.goals.forPartner(partnerId),
        });
        queryClient.invalidateQueries({
          queryKey: queryKeys.partners.detail(partnerId),
        });
      }
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete goal");
    },
  });
}
